<div class="modal fade" id="modalCatalogVersions" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-big-2 modal-dialog-scrollable">
        <div class="modal-content">

            <!-- Header con datos del item -->
            <div class="modal-header">
                <div class="d-flex flex-column">
                    <h5 class="modal-title mb-1">
                        <i class="fa-solid fa-layer-group me-2"></i>
                        Versiones del ítem #{{ itemHeader?.id }}
                    </h5>
                    <div class="small text-muted d-flex flex-wrap gap-3">
                        <span>
                            <i class="fa-solid fa-tag me-1"></i>
                            <strong>Tipo:</strong> {{ itemHeader?.functionalTypeName || '—' }}
                        </span>
                        <span>
                            <i class="fa-solid fa-briefcase me-1"></i>
                            <strong>Servicio:</strong> {{ itemHeader?.availableServiceName || 'N/A' }}
                        </span>
                        <span>
                            <i class="fa-solid fa-bullhorn me-1"></i>
                            <strong>Publicado:</strong>
                            <span class="badge rounded-pill"
                                [ngClass]="itemHeader?.publishedVersionId ? 'text-bg-success' : 'text-bg-warning'">
                                {{ itemHeader?.publishedVersionNumber ? ('#' + itemHeader?.publishedVersionNumber) : 'Sin publicar' }}
                            </span>
                        </span>
                        <span>
                            <i class="fa-solid fa-user me-1"></i>
                            <strong>Creado por:</strong> {{ itemHeader?.createdByName || '—' }}
                            <span class="ms-2"><i class="fa-regular fa-clock me-1"></i>{{ itemHeader?.createdAt |
                                date:'dd/MM/yyyy hh:mm a' }}</span>
                        </span>
                        <span>
                            <i class="fa-solid fa-circle me-1"
                                [ngClass]="itemHeader?.isDeleted ? 'text-danger' : 'text-success'"></i>
                            <strong>Estado:</strong> {{ itemHeader?.isDeleted ? 'Eliminado' : 'Activo' }}
                        </span>
                    </div>
                </div>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
            </div>

            <!-- Filtros -->
            <div class="modal-body">
                <div class="card mb-3">
                    <div class="card-body">
                 <div class="row g-3 align-items-end">
                    <!-- Buscar -->
                    <div class="col-12 col-md-4">
                        <label class="form-label">Buscar</label>
                        <input class="form-control" type="text" [(ngModel)]="filter.filterValue"
                            placeholder="Título, subtítulo." />
                    </div>

                    <!-- Filtrar por -->
                    <div class="col-12 col-md-3">
                        <label class="form-label">Filtrar por</label>
                        <select class="form-select" [(ngModel)]="filter.filterKey">
                        <option value="">Seleccione un filtro</option>
                        <option value="title">Título</option>
                        <option value="subtitle">Subtítulo</option>
                        </select>
                    </div>

                    <!-- Estado -->
                    <div class="col-6 col-md-2">
                        <label class="form-label">Estado</label>
                        <select class="form-select" [(ngModel)]="filter.statusCode">
                        <option value="">Todos</option>
                        <option value="DRAFT">BORRADOR</option>
                        <option value="PUBLISHED">PUBLICADA</option>
                        <option value="RETIRED">RETIRADA</option>
                        </select>
                    </div>

                    <!-- Versión -->
                    <div class="col-6 col-md-2">
                        <label class="form-label">Versión #</label>
                        <input type="number" class="form-control" min="1" step="1"
                            [(ngModel)]="filter.versionNumber" placeholder="Ej. 3" />
                    </div>

                    <!-- Botones Buscar + Limpiar -->
                    <div class="col-12 col-md-1 d-flex gap-2">
                        <button type="button" class="btn btn-primary flex-fill" (click)="onSearch()" title="Buscar">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                        <button type="button" class="btn btn-outline-secondary flex-fill" (click)="resetFilters(); load()" title="Limpiar">
                        <i class="fa-solid fa-eraser"></i>
                        </button>
                    </div>
                    </div>

                    </div>
                </div>

                <!-- Tabla -->
                <div class="table-responsive">
                    <table class="table table-theme align-middle">
                        <thead>
                            <tr>
                                <th class="text-start">Versión</th>
                                <th class="text-start">Estado</th>
                                <th class="text-start">Título</th>
                                <th class="text-end">Precio</th>
                                <th class="text-center">ITBIS</th>
                                <th class="text-center">Audiencia</th>
                                <th class="text-center">Auditoría</th>
                                <th class="text-center">Acciones</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngIf="!loadingSvc.loading() && versions.length === 0">
                                <td colspan="8" class="text-center py-4">
                                    <i class="fa-solid fa-info-circle me-2"></i>
                                    No se encontraron versiones.
                                </td>
                            </tr>

                            <tr *ngFor="let v of versions">
                                <td class="text-start">
                                    <span class="badge rounded-pill text-bg-secondary">#{{ v.versionNumber }}</span>
                                </td>

                                <td class="text-start">
                                <span class="badge rounded-pill" 
                                [ngClass]="{
                                'bg-secondary text-white': v.statusCode==='Draft',
                                'bg-success text-white': v.statusCode==='Published',
                                'bg-danger text-white': v.statusCode==='Retired'
                                }"
                                        title="{{ v.statusName }}">
                                    {{ v.statusName }}
                                </span>
                                </td>


                                <td class="text-start">
                                    <div class="fw-semibold">{{ v.title || '—' }}</div>
                                    <div class="small text-muted text-truncate" style="max-width: 420px;"
                                        [title]="v.shortDescription">
                                        {{ v.shortDescription || '—' }}
                                    </div>
                                </td>

                                <td class="text-end">
                                    <div class="fw-semibold">
                                        {{ (v.basePrice ?? 0) | currency:'DOP':'symbol-narrow':'1.0-2' }}
                                    </div>
                                </td>

                                <td class="text-center">
                                    <span class="badge rounded-pill"
                                        [ngClass]="v.appliesITBIS ? 'text-bg-info' : 'text-bg-light'">
                                        {{ v.appliesITBIS ? 'Sí' : 'No' }}
                                    </span>
                                </td>

                                <td class="text-center">
                                    <div class="d-flex gap-1 justify-content-center flex-wrap">
                                        @if(v.eligibleCompany){
                                            <span class="badge rounded-pill"
                                            [ngClass]="v.eligibleCompany ? 'text-bg-primary' : 'text-bg-light'">Empresa</span>
                                        }
                                        @if(v.eligibleCandidate){
                                            <span class="badge rounded-pill"
                                            [ngClass]="v.eligibleCandidate ? 'text-bg-primary' : 'text-bg-light'">Candidato</span>
                                        }
                                        @if(v.eligibleFreelance){
                                            <span class="badge rounded-pill"
                                            [ngClass]="v.eligibleFreelance ? 'text-bg-primary' : 'text-bg-light'">Independiente</span>
                                        }
                                    </div>
                                </td>

                                <td class="text-center ">
                                <div class="dropdown ">
                                    <button
                                    type="button"
                                    class="btn btn-sm btn-outline-secondary dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    data-bs-display="static"
                                    data-bs-boundary="viewport"
                                    aria-expanded="false">
                                    Auditoría
                                    </button>

                                    <div class="dropdown-menu dropdown-menu-end shadow audit-dropdown p-0">
                                    <div class="list-group list-group-flush small">

                                        <!-- Creación -->
                                        <div class="list-group-item">
                                        <div class="fw-semibold d-flex align-items-center gap-2">
                                            <i class="fa-solid fa-circle-plus"></i> Creación
                                        </div>
                                        <div class="mt-1"><i class="fa-solid fa-user-pen me-1"></i>{{ v.createdByName || '—' }}</div>
                                        <div class="text-muted"><i class="fa-regular fa-clock me-1"></i>{{ v.createdAt | date:'dd/MM/yyyy hh:mm a' }}</div>
                                        </div>

                                        <!-- Edición -->
                                        <div class="list-group-item" *ngIf="v.updatedAt && v.updatedBy">
                                        <div class="fw-semibold d-flex align-items-center gap-2">
                                            <i class="fa-solid fa-pen-to-square"></i> Edición
                                        </div>
                                        <div class="mt-1"><i class="fa-solid fa-user-pen me-1"></i>{{ v.updatedByName || '—' }}</div>
                                        <div class="text-muted"><i class="fa-regular fa-clock me-1"></i>{{ v.updatedAt | date:'dd/MM/yyyy hh:mm a' }}</div>
                                        </div>

                                        <!-- Publicación -->
                                        <div class="list-group-item" *ngIf="v.publishedAt">
                                        <div class="fw-semibold d-flex align-items-center gap-2">
                                            <i class="fa-solid fa-bullhorn"></i> Publicación
                                        </div>
                                        <div class="mt-1"><i class="fa-solid fa-user-check me-1"></i>{{ v.publishedByName || '—' }}</div>
                                        <div class="text-muted"><i class="fa-regular fa-clock me-1"></i>{{ v.publishedAt | date:'dd/MM/yyyy hh:mm a' }}</div>
                                        </div>

                                        <!-- Retiro -->
                                        <div class="list-group-item" *ngIf="v.retiredAt">
                                        <div class="fw-semibold d-flex align-items-center gap-2">
                                            <i class="fa-solid fa-box-archive"></i> Retiro
                                        </div>
                                        <div class="mt-1"><i class="fa-solid fa-user-xmark me-1"></i>{{ v.retiredByName || '—' }}</div>
                                        <div class="text-muted"><i class="fa-regular fa-clock me-1"></i>{{ v.retiredAt | date:'dd/MM/yyyy hh:mm a' }}</div>
                                        </div>

                                    </div>
                                    </div>
                                </div>
                                </td>
                                 <td class="text-center">
                                    <div class="d-flex justify-content-center gap-2 flex-wrap">
                                        <button
                                        type="button"
                                        class="btn btn-sm btn-outline-secondary"
                                        title="Editar versión"
                                        *ngIf=" (v.latestVersionNumber || (v.statusCode || '' | uppercase) === 'PUBLISHED') "
                                        (click)="editVersion(v)">
                                        <i class="fa-solid fa-pen-to-square"></i> 
                                        </button>

                                         <button
                                        type="button"
                                        class="btn btn-sm btn-success"
                                        title="Publicar esta versión"
                                        *ngIf="(v.statusCode || '' | uppercase) === 'DRAFT' && v.latestVersionNumber"
                                        (click)="publishVersion(v)">
                                        <i class="fa-solid fa-bullhorn"></i> 
                                        </button>

                                        <button
                                        type="button"
                                        class="btn btn-sm btn-danger"
                                        title="Retirar versión publicada"
                                        *ngIf="(v.statusCode || '' | uppercase) === 'PUBLISHED'"
                                        (click)="retireVersion(v)">
                                        <i class="fa-solid fa-box-archive"></i> 
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-primary"
                                            title="Ver versión"
                                            (click)="viewVersion(v)">
                                            <i class="fa-solid fa-eye"></i> 
                                         </button>
                                         @if(v.versionNumber !== 1){
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-outline-primary"
                                                title="Ver diferencias"
                                                (click)="openDiffModal(v)">
                                                <i class="fa-solid fa-code-compare"></i>
                                            </button>
                                         }
                                    </div>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="mt-3" *ngIf="versions.length > 0">
                    <app-pagination [page]="filter.page" [pageSize]="filter.pageSize" [totalItems]="totalItems"
                        (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)">
                    </app-pagination>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>

<app-modal-catalog-wizard modalId="modalCatalogWizardVersion" (changeData)="load(); changeData.emit()"/>
<app-catalog-diff />